import { HttpErrorResponse } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, inject, DestroyRef ,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { DSTSharedService } from 'projects/gtw-elements/src/app/DST/shared/dst-shared.service';
import { TaxTypePipe } from 'projects/gtw-elements/src/app/DST/shared/pipes/taxtype.pipe';
import { EMPTY, forkJoin, Observable, switchMap, tap } from 'rxjs';
import { StmtAttrData, StmtData } from '../../../../../../shared/models/dst-form-state.model';
import { CreateDisclosureSharedService, DropDownType, dstLookupEntity, EntityNameChange } from '../../../create-disclosure-shared.service';
import { DSTEntityDetails } from '../../template-leid-selector/template-leid-selector.component';

@Component({
    selector: 'dst-view-template-sec351-id184',
    templateUrl: './view-template-sec351-id184.component.html',
    styleUrls: ['../../template-shared.scss', './view-template-sec351-id184.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ViewTemplateSec351Id184Component implements OnInit {
  private readonly destroyRef = inject(DestroyRef);


  @Output('onCancel') onCancel: EventEmitter<null> = new EventEmitter<null>();

  form184!: UntypedFormGroup;
  selectedOptionID!: number;
  beginDate!: Date;
  endDate!: Date;
  defaultDate!: Date;
  isSection304Related: boolean;
  stmtData!: StmtData;
  stmtAttrData: any = [];
  loaded: boolean = false;
  attrData: any = [];
  pickListVal: string = '';
  liquidationDate: any = [];
  attMap: any;
  isBranchEntity!: boolean;
  selTransferee: DSTEntityDetails[] = [];
  selTransferor: DSTEntityDetails[] = [];
  lookupdata: any = [];
  currencyOptions: any = [];
  stockTypeOptions: any = [];
  liquidationStateOptions: any = [];
  decsArray: any = [];
  sec304Check: boolean = false;
  descTotalAvl: boolean = false;
  basisAmt1Total: boolean = false;
  propertyValBasisOptions: any = [];
  selBasisTxt: string = '';
  selStockTypeTxt: string = '';
  startLoader: boolean = false;
  disableActions: boolean = false;
  displaySharedOwnershipInfo: boolean = false;
  s3Uploading: boolean = false;
  noAddShares: boolean = false;
  primaryCorpTypeTxt: string = '';
  secondaryCorpTypeTxt: string = '';
  shCorpTypeTxt: string = '';
  primaryEntityName: string = '';
  secondaryEntityName: string = '';

  constructor(private formBuilder: UntypedFormBuilder,
    private dstSharedService: DSTSharedService,
    private sharedService: CreateDisclosureSharedService,
    private taxTypePipe: TaxTypePipe,
    private cdr: ChangeDetectorRef) {
    this.isSection304Related = false;
    this.disableActions = this.sharedService.disableActions;
    this.sharedService.disableActions = false; // reset immediately after consumed
  }

  ngOnInit(): void {
    this.startLoader = true;
    this.form184 = this.formBuilder.group({
      header: this.formBuilder.group({
        consolGroup: ['', Validators.required],
        options: ['']
      })
    });

    //load currencies
    this.sharedService.getCurrencyDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach(element => {
          this.currencyOptions.push({
            value: element.id,
            label: element.text
          });
        });
      }, () => {

      }, () => {

      });

    //
    this.sharedService.getStockTypeListDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach(element => {
          this.stockTypeOptions.push({
            value: element.id,
            label: element.text
          });
        });
      }, () => {

      }, () => {
        this.selStockTypeTxt = this.stockTypeOptions[0]?.label || '';
      });

    //Load both basis options and statement data together to avoid race condition
    forkJoin([
      this.sharedService.getBasisDropdown(),
      this.sharedService.getLoadStatementData(184)
    ]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(([basisData, stmtResponse]) => {
      //Load basis options
      basisData.forEach(element => {
        this.propertyValBasisOptions.push({
          value: element.id,
          label: element.text
        });
      });

      //Load statement data
      this.stmtData = stmtResponse;
      this.primaryEntityName = this.stmtData.primaryentity || '';
      this.secondaryEntityName = this.stmtData.secondaryentity || '';

      //load all attributes into new object for showing on UI as key value pair
      this.attMap = {};

      this.stmtData.children?.forEach((stmt: StmtAttrData) => {
        if (!this.attMap[stmt.attributeName]) {
          this.attMap[stmt.attributeName] = [];
        }

        if (stmt.attributeValue !== undefined) {
          this.attMap[stmt.attributeName]?.push(stmt.attributeValue);
        } else {
          //console.log('stmt.attributeName---'+ stmt.attributeName);
          this.attMap[stmt.attributeName]?.push('');
        }
      });
      console.log('After loop Attr data' + JSON.stringify(this.attMap));

      //check totals are available
      if (this.attMap['Desc'] && this.attMap['Desc'].length >= 1) {
        this.descTotalAvl = true;
      }
      if (this.attMap['Desc1'] && this.attMap['Desc1'].length >= 1 && this.checkArrayHasNonEmptyValues(this.attMap['Desc1'])) {
        this.basisAmt1Total = true;
      }

      //shared/ownership info
      if ((this.attMap['ShareX'] !== undefined && this.attMap['ShareX'][0] !== '')
        || (this.attMap['ShareY'] !== undefined && this.attMap['ShareY'][0] !== '')
        || (this.attMap['PercentageX'] !== undefined && this.attMap['PercentageX'][0] !== '')
        || (this.attMap['PercentageY'] !== undefined && this.attMap['PercentageY'][0] !== '')) {

        if ((this.attMap['ShareX'][0] !== undefined && this.attMap['ShareY'][0] !== undefined) && (this.attMap['ShareX'][0] === this.attMap['ShareY'][0])) {
          this.noAddShares = true;
        } else {
          this.displaySharedOwnershipInfo = true;
        }
      }

      //check for 351 - 304 Transaction
      this.check304Type();

      //Set all the values that needed from the service calls
      this.propertyValBasisOptions.forEach((val: { value: number; label: string }) => {
        if ((this.attMap['Basis'] !== undefined) && (val.value == this.attMap['Basis'][0])) {
          this.selBasisTxt = val.label;
        }
      });

      this.stockTypeOptions.forEach((val: { value: number; label: string }) => {
        if ((this.attMap['StockType'] !== undefined) && (val.value == this.attMap['StockType'][0])) {
          this.selStockTypeTxt = val.label;
        }
      });

      //corpTypeTxt
      //this.updateEntitiesInfo(this.stmtData?.primaryleid!, 1);
      //this.updateEntitiesInfo(this.stmtData?.secondaryleid!, 2);
      
    }, (error) => {
      console.error('Error loading data:', error);
    }, () => {
      this.loaded = true;
      this.startLoader = false;
    });

  }

  private loadOtherEntityInfoAndUploadPdf() {
    forkJoin([
      this.updateEntitiesInfo(this.stmtData?.primaryleid!, 1),
      this.updateEntitiesInfo(this.stmtData?.secondaryleid!, 2)
    ]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(([response1, response2]) => {
      this.cdr.detectChanges();
      
      requestAnimationFrame(() => {
        setTimeout(() => {
          const formState = this.sharedService.getFormStateByFormId(184);
          if (!formState?.doPDFSync) {
            return;
          }
          const html = document.querySelector('#temp351form184');
          if (!html) {
            console.warn('view-template-sec351-id184: #temp351form184 not in DOM at PDF-sync time; skipping conversion.');
            return;
          }
          this.htmlToPdfConversion(html.outerHTML);
        }, 0);
      });
    }, (error: HttpErrorResponse) => {

      console.log(error);

      this.dstSharedService.showAlert('error', error.message);

    }).add(() => {
      this.loaded = true;
      this.startLoader = false;
    });
  }

  htmlToPdfConversion(htmlContent: string, isS3upload: boolean = false): void {
    this.sharedService.saveHTMLToPDFStatement(htmlContent!, 'Section351-StatementPursuant.pdf', this.stmtData.statementid).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: any) => {
        isS3upload && (this.dstSharedService.showAlert('success', 'The Form got successfully uploaded to S3!'));
        isS3upload && (this.s3Uploading = false);
      }, (eMsg: string) => {
        console.log(eMsg);
        isS3upload && (this.dstSharedService.showAlert('error', eMsg));
      });
  }

  s3Upload(): void {
    this.s3Uploading = true;
    const html = document.querySelector('#temp351form184');
    const htmlContent = html!.outerHTML;
    this.htmlToPdfConversion(htmlContent, true);
  }

  // updateEntitiesInfo(leid: string, entityType: number): void {
  //   this.startLoader = true;
  //   this.sharedService.checkForEntityNameChange(this.stmtData?.statementid.toString(),
  //     leid,
  //     this.attMap['LiquidationDate'] != undefined ? this.attMap['LiquidationDate'][0]: null,
  //     this.sharedService.getActiveFormState().taxYear.toString()
  //   ).subscribe((response: EntityNameChange[]) => {
  //     if (response && response[0]) {
  //       //override entity type
  //       const corpType = this.taxTypePipe.transform(response[0], response[0].TAXTYPECODE, true);
  //       if (entityType === 1) { //primary entity
  //         (response[0].LE_NAME) && (this.primaryEntityName = response[0].LE_NAME);
  //         this.primaryCorpTypeTxt = corpType;
  //       } else if (entityType === 2) { //secondary entity
  //         (response[0].LE_NAME) && (this.secondaryEntityName = response[0].LE_NAME);
  //         this.secondaryCorpTypeTxt = corpType;
  //       } else if (entityType === 3) { //share holder entity
  //         this.shCorpTypeTxt = corpType;
  //       }
  //     }
  //   }, (error: HttpErrorResponse) => {
  //     console.log(error);
  //     this.dstSharedService.showAlert('error', error.message);
  //   }).add(() => {
  //     this.startLoader = false;
  //   });
  // }

  updateEntitiesInfo(leid: string, entityType: number): Observable<EntityNameChange[]> {
    this.startLoader = true;
    
    // Safely get formState with try-catch
    let taxYear: string;
    try {
      const formState = this.sharedService.getActiveFormState();
      taxYear = formState?.taxYear?.toString() || new Date().getFullYear().toString();
    } catch (error) {
      console.warn('Could not get active form state, using current year as fallback:', error);
      taxYear = new Date().getFullYear().toString();
    }
    
    return this.sharedService.checkForEntityNameChange(this.stmtData?.statementid.toString(),
      leid,
      this.attMap['LiquidationDate'] != undefined ? this.attMap['LiquidationDate'][0] : null,
      taxYear
    ).pipe(
      tap({
        next: (response => {
          if (response && response[0]) {
            //override entity type
            const corpType = this.taxTypePipe.transform(response[0], response[0].TAXTYPECODE, true);
            if (entityType === 1) { //primary entity
              (response[0].LE_NAME) && (this.primaryEntityName = response[0].LE_NAME);
              this.primaryCorpTypeTxt = corpType;
            } else if (entityType === 2) { //secondary entity
              (response[0].LE_NAME) && (this.secondaryEntityName = response[0].LE_NAME);
              this.secondaryCorpTypeTxt = corpType;
            } else if (entityType === 3) { //share holder entity
              this.shCorpTypeTxt = corpType;
            }
          }
        })
      })
    )
  }

  checkArrayHasNonEmptyValues(item: any[]): boolean {
    return !item.every(ele => ele.length < 1);
  }

  check304Type(): void {

    if (this.attMap['' +
      'CheckFor351Transfer'] !== undefined && this.attMap['CheckFor351Transfer'][0] === '1') {

      this.lookupdata = [];

      //populateSHFields — flattened two-level subscribe into a single
      // switchMap pipeline.
      if (this.attMap['SHdspTransferorLEID'] !== undefined) {
        this.sharedService
          .getDSTEntityInfo(this.attMap['SHdspTransferorLEID'][0])
          .pipe(
            switchMap((data: dstLookupEntity[]) => {
              if (!data || !data[0]) return EMPTY;
              this.lookupdata.push(data[0]);
              return this.updateEntitiesInfo(this.lookupdata[0].LEID, 3).pipe(
                tap(() => {
                  this.cdr.detectChanges();
                  this.loadOtherEntityInfoAndUploadPdf();
                }),
              );
            }), takeUntilDestroyed(this.destroyRef),
          )
          .subscribe();
      } else {
        this.loadOtherEntityInfoAndUploadPdf();
      }

      //Select pickList Val
      this.sharedService.getLiquidationStateDropdown(2).pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data: DropDownType[]) => {
          data.forEach(element => {
            if (this.attMap['TransfereesNote'] && element.id == this.attMap['TransfereesNote'][0]) {
              this.pickListVal = element.text;
            }

          });
        }, () => {

        }, () => {

        });
      this.sec304Check = true;
    } else {
      this.loadOtherEntityInfoAndUploadPdf();
    }
  }

  /*//getSelectedBasis
  getSelBasis(): string {
    console.log('TEst---');
    let retnValue = '';
    this.propertyValBasisOptions.forEach((val: { value: any; label: string }) => {

      if (val.value == this.attMap['Basis'][0]) {
         retnValue = val.label;
      }

    });
    return retnValue;
  }*/

  //getCurrencyText
  getSelCurrency(valFor?: number): string {
    let retVal = '';
    this.currencyOptions.forEach((val: { value: number; label: string }) => {
      if (this.attMap['Currency'] && val.value == this.attMap['Currency'][0] && valFor == 0) {
        retVal = val.label;
      } else if (this.attMap['Currency'] && val.value == this.attMap['Currency'][1] && valFor == 1) {

        retVal = val.label;
      } else if (this.attMap['Currency'] && val.value == this.attMap['Currency'][2] && valFor == 2) {

        retVal = val.label;
      }

    });

    return retVal;
  }

  getSelShares(): string {
    let retVal = '';
    this.stockTypeOptions.forEach((val: { value: any; label: string }) => {
      if (this.attMap['StockType304'] && val.value == this.attMap['StockType304'][0]) {
        retVal = val.label;
      }
    });

    return retVal;
  }

  totalAmt(amtFor?: String): number {
    let totalAmt = 0;
    const addAmt = (amt: any) => {
      const value = Number(String(amt ?? '').replace(/,/g, ''));
      if (Number.isFinite(value)) {
        totalAmt += value;
      }
    };
    if (amtFor == 'BasisAmt' && this.attMap['BasisAmt'] !== undefined) {
      this.attMap['BasisAmt'].forEach(addAmt);
    } else if (amtFor == 'FMVAmt' && this.attMap['FMVAmt'] !== undefined) {
      this.attMap['FMVAmt'].forEach(addAmt);
    } else if (amtFor == 'BasisAmt1' && this.attMap['BasisAmt1'] !== undefined) {
      this.attMap['BasisAmt1'].forEach(addAmt);
    }
    return totalAmt;
  }

  dummyFunc(event: any): void {

  }

  save(): void {
    this.sharedService.setFormData(this.stmtData);
    this.sharedService.setSavedStatementId(this.stmtData.statementid.toString());
    this.sharedService.switchTemplateMode(false);
  }

  cancel(): void {
    this.onCancel.emit();
  }

}
